import styled from 'styled-components';

export const Container = styled.main`
  display: flex;
  flex-direction: column;
  max-height: 100vh;
  overflow: auto;
  padding: 32px;

  @media screen and (max-width: 950px) {
    height: 100%;
    max-height: 100%;
  }
`;

export const List = styled.ul`
  display: flex;
  flex-direction: column;

  @media screen and (max-width: 950px) {
    max-height: 100%;
    height: 100%;
  }
`;

export const ListCount = styled.span`
  font-size: 0.9rem;
  color: ${(props) => props.theme.colors.grey};
  align-self: flex-end;
`;

export const EmptyText = styled.p`
  color: ${(props) => props.theme.colors.grey};
  text-align: center;
`;
